import React from "react";
import { Flex, Image } from "@fluentui/react-northstar";
import { BASE_URL_ILLUSTRATIONS } from "../../../constants";

import {
    EmptyTaskDescription,
    EmptyTasksTitle,
    TitleMyTask,
    WrapperMytask,
} from "../style";
import ViewTable from "../ViewTable";

const MyTasks = ({
    tasks = [],
    isPageOnboarding = null,
    user,
    activeTab,
    AgencyId,
    isFetchingUserDetail,
    isPageOffboarding,
}) => {
    return (
        <>
            {tasks && tasks?.length > 0 ? (
                <>
                    <WrapperMytask column fill>
                        {!isPageOnboarding && !isPageOffboarding && (
                            <TitleMyTask content="Liste de mes tâches" />
                        )}
                        <ViewTable
                            isPageOffboarding={isPageOffboarding}
                            user={user}
                            tasksProps={{ tasks }}
                            isPageOnboarding={isPageOnboarding}
                            activeTab={activeTab}
                            AgencyId={AgencyId}
                        />
                    </WrapperMytask>
                </>
            ) : isPageOnboarding ? (
                <Flex
                    column
                    fill
                    vAlign="center"
                    hAlign="center"
                    gap="gap.large"
                >
                    <Flex>
                        <Image
                            src={`${BASE_URL_ILLUSTRATIONS}/Tasks-No_task.svg`}
                            alt="empty tasks"
                        />
                    </Flex>
                    <Flex
                        column
                        vAlign="center"
                        hAlign="center"
                        gap="gap.small"
                    >
                        <EmptyTasksTitle>
                            Aucune tâche à réaliser par le collaborateur
                        </EmptyTasksTitle>
                    </Flex>
                </Flex>
            ) : (
                <Flex
                    column
                    fill
                    vAlign="center"
                    hAlign="center"
                    gap="gap.large"
                >
                    <Flex>
                        <Image
                            src={`${BASE_URL_ILLUSTRATIONS}/No-task-todo.svg`}
                            alt="empty tasks"
                        />
                    </Flex>
                    <Flex
                        column
                        vAlign="center"
                        hAlign="center"
                        gap="gap.small"
                    >
                        <EmptyTasksTitle>
                            Aucune tâche à effectuer
                        </EmptyTasksTitle>
                        <EmptyTaskDescription>
                            Vous n’avez pas de tâche à faire,
                            <br />
                            c’est parfait !
                        </EmptyTaskDescription>
                    </Flex>
                </Flex>
            )}
        </>
    );
};

export default MyTasks;
